export enum DocType {
  BillOfLading = 'BL',
  DeliveryReceipt = 'DR',
  LetterOfAuthorization = 'LOA',
  InvoicePdf = 'ARIN',
  WeightInspectionCertificate = 'WI',
  NmfcClassInspectionCertificate = 'NCIC',
  Customs = 'CUST'
}
